import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPlayComponent } from "./med-icon-play.component";

@NgModule({
  declarations: [
    MedIconPlayComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPlayComponent,
  ],
})
export class MedIconPlayModule { }
